import React from "react";
import { ITheme, IDefinitions, buildClasses } from "@nodeme/jss-react";
import Headline from "./Headline";
import Text from "./Text";
import Button from "@nodeme/forms-react/lib/Components/Button";
import { Text as TextF } from "@nodeme/forms-react";
import { Grid } from "@nodeme/grid-react";

interface IContact {
  previouse: () => void;
  next: () => void;
  onChange: (value?: string) => void;
  value: string | undefined;
  error: string | undefined;
}

const styles = (theme: ITheme) => (definitions: IDefinitions) => ({
  alignRight: {
    textAlign: "right",
  },
});

const Info: React.FC<IContact> = (props) => {
  const classes = buildClasses(styles, props);
  return (
    <div>
      <Headline>DATEN</Headline>
      <Text>
        Es muss nicht dein echter Name sein, aber Marlies und Bendi sollten
        wissen wer ihnen schreibt.
      </Text>
      <div>
        <TextF
          inline
          label="Name"
          onChange={props.onChange}
          value={props.value}
          error={props.error}
        />
      </div>
      <Grid spacing={8} root={{ top: 16, left: 0, right: 0 }}>
        <Grid item xs={5}>
          <Button width="120px" onClick={() => props.previouse()}>
            Zurück
          </Button>
        </Grid>
        <Grid item xs={5}>
          <div className={classes.alignRight}>
            <Button
              disabled={!props.value}
              primary
              width="120px"
              onClick={() => props.next()}
            >
              Weiter
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Info;
